import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Navigation from "@/components/Navigation";
import { Footer } from "@/components/Footer";

const PolitykaPrywatnosci = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Polityka prywatności - WystepKomediowy.pl</title>
        <meta name="description" content="Polityka prywatności serwisu WystepKomediowy.pl. Zasady przetwarzania i ochrony danych osobowych." />
        <link rel="canonical" href="https://wystepkomediowy.pl/polityka-prywatnosci" />
        <meta property="og:title" content="Polityka prywatności - WystepKomediowy.pl" />
        <meta property="og:description" content="Polityka prywatności serwisu WystepKomediowy.pl." />
        <meta property="og:url" content="https://wystepkomediowy.pl/polityka-prywatnosci" />
      </Helmet>
      <Navigation />
      <main className="pt-32 pb-20">
        <div className="container max-w-3xl mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-montserrat font-bold text-primary mb-8">
            Polityka <span className="gradient-text">prywatności</span>
          </h1>

          <div className="prose prose-gray max-w-none space-y-6 text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">1. Informacje ogólne</h2>
              <p>Niniejsza Polityka prywatności określa zasady przetwarzania i ochrony danych osobowych użytkowników serwisu WystepKomediowy.pl, prowadzonego przez Wirtualny Biznes, ul. Księcia Witolda 49/15, 50-202 Wrocław, NIP: 8961619199.</p>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">2. Zakres zbieranych danych</h2>
              <p>Serwis zbiera dane osobowe wyłącznie w zakresie niezbędnym do świadczenia usług. Dane zbierane poprzez formularz kontaktowy obejmują:</p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Imię i nazwisko</li>
                <li>Adres e-mail</li>
                <li>Numer telefonu</li>
                <li>Treść wiadomości</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">3. Pliki cookies</h2>
              <p>Serwis wykorzystuje pliki cookies w celu zapewnienia prawidłowego działania strony, analizy ruchu oraz dostosowania treści do preferencji użytkownika. Użytkownik może w każdej chwili zmienić ustawienia dotyczące plików cookies w swojej przeglądarce internetowej.</p>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">4. Udostępnianie danych</h2>
              <p>Dane osobowe użytkowników nie są udostępniane podmiotom trzecim, z wyjątkiem sytuacji przewidzianych przepisami prawa lub gdy jest to niezbędne do realizacji usługi (np. hosting, obsługa poczty elektronicznej).</p>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">5. Bezpieczeństwo danych</h2>
              <p>Administrator stosuje odpowiednie środki techniczne i organizacyjne zapewniające ochronę przetwarzanych danych osobowych, w szczególności zabezpiecza dane przed ich udostępnieniem osobom nieupoważnionym, utratą czy uszkodzeniem.</p>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">6. Zmiany Polityki prywatności</h2>
              <p>Administrator zastrzega sobie prawo do wprowadzania zmian w niniejszej Polityce prywatności. Aktualna wersja jest zawsze dostępna na stronie serwisu.</p>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">7. Kontakt</h2>
              <p>W razie pytań dotyczących Polityki prywatności prosimy o kontakt: <a href="mailto:kontakt@wystepkomediowy.pl" className="text-brand-purple hover:underline">kontakt@wystepkomediowy.pl</a></p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PolitykaPrywatnosci;
